import { COUNTRY_CODE, CURRENCY_CODE } from 'constants/payment';
import locale from './locale.json';
export const getCountryCode = () => {
  return localStorage?.getItem(COUNTRY_CODE);
};

export const setCountryCode = (countryCode = 'de') => {
  const findLocale = locale.find(
    (item) => item.country?.toUpperCase() === countryCode?.toUpperCase(),
  );

  localStorage?.setItem(COUNTRY_CODE, findLocale?.full_locale || 'de-DE');
};

export const getCurrencyCode = () => {
  return localStorage?.getItem(CURRENCY_CODE);
};

export const setCurrencyCode = (currencyCode = 'EUR') => {
  localStorage?.setItem(CURRENCY_CODE, currencyCode?.toUpperCase());
};
